var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgManifestHistory = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#000",
  strokeLinecap: "round",
  strokeMiterlimit: 10,
  d: "M2.875 1.375v3.75M6.625 5.125h-3.75M10 1.375a8.626 8.626 0 0 1 0 17.25A8.626 8.626 0 0 1 1.375 10M2.89 5.125A8.6 8.6 0 0 1 10 1.375M10.375 5.125v5.25M14.875 10.375h-4.5"
})));
export default SvgManifestHistory;